import React from 'react';
import { HeaderScreenContainer, HeaderScreenContainerContentTitle } from './styles';
 
function HeaderScreen() {

  return <HeaderScreenContainer>
            <HeaderScreenContainerContentTitle>
                <h1>FINALIZE SEU PEDIDO</h1>
            </HeaderScreenContainerContentTitle>
          </HeaderScreenContainer>;
}
 
export default HeaderScreen;

// class ScoreStepByStep extends Component{
//     constructor(props){
//         super(props);
//         this.state = {}
//     }

//     render(){
//         return(
            
//         )
//     }
// }
